/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCallFeedbacks200Response } from '../models';
/**
 * CallFeedbackApi - axios parameter creator
 * @export
 */
export const CallFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * コールFB一覧取得API
         * @summary コールFB一覧取得API
         * @param {number} [page] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<number>} [userIds] 
         * @param {Array<string>} [connectedTo] 
         * @param {Array<number>} [callResultTypeIds] 
         * @param {Array<number>} [defaultCallResultTypeIds] 
         * @param {number} [callResultId] 
         * @param {boolean} [unconfirmed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallFeedbacks: async (page?: number, startDate?: string, endDate?: string, userIds?: Array<number>, connectedTo?: Array<string>, callResultTypeIds?: Array<number>, defaultCallResultTypeIds?: Array<number>, callResultId?: number, unconfirmed?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_feedbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }

            if (userIds) {
                localVarQueryParameter['user_ids[]'] = userIds;
            }

            if (connectedTo) {
                localVarQueryParameter['connected_to[]'] = connectedTo;
            }

            if (callResultTypeIds) {
                localVarQueryParameter['call_result_type_ids[]'] = callResultTypeIds;
            }

            if (defaultCallResultTypeIds) {
                localVarQueryParameter['default_call_result_type_ids[]'] = defaultCallResultTypeIds;
            }

            if (callResultId !== undefined) {
                localVarQueryParameter['call_result_id'] = callResultId;
            }

            if (unconfirmed !== undefined) {
                localVarQueryParameter['unconfirmed'] = unconfirmed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallFeedbackApi - functional programming interface
 * @export
 */
export const CallFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * コールFB一覧取得API
         * @summary コールFB一覧取得API
         * @param {number} [page] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<number>} [userIds] 
         * @param {Array<string>} [connectedTo] 
         * @param {Array<number>} [callResultTypeIds] 
         * @param {Array<number>} [defaultCallResultTypeIds] 
         * @param {number} [callResultId] 
         * @param {boolean} [unconfirmed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallFeedbacks(page?: number, startDate?: string, endDate?: string, userIds?: Array<number>, connectedTo?: Array<string>, callResultTypeIds?: Array<number>, defaultCallResultTypeIds?: Array<number>, callResultId?: number, unconfirmed?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallFeedbacks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallFeedbacks(page, startDate, endDate, userIds, connectedTo, callResultTypeIds, defaultCallResultTypeIds, callResultId, unconfirmed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallFeedbackApi - factory interface
 * @export
 */
export const CallFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallFeedbackApiFp(configuration)
    return {
        /**
         * コールFB一覧取得API
         * @summary コールFB一覧取得API
         * @param {number} [page] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<number>} [userIds] 
         * @param {Array<string>} [connectedTo] 
         * @param {Array<number>} [callResultTypeIds] 
         * @param {Array<number>} [defaultCallResultTypeIds] 
         * @param {number} [callResultId] 
         * @param {boolean} [unconfirmed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallFeedbacks(page?: number, startDate?: string, endDate?: string, userIds?: Array<number>, connectedTo?: Array<string>, callResultTypeIds?: Array<number>, defaultCallResultTypeIds?: Array<number>, callResultId?: number, unconfirmed?: boolean, options?: any): AxiosPromise<GetCallFeedbacks200Response> {
            return localVarFp.getCallFeedbacks(page, startDate, endDate, userIds, connectedTo, callResultTypeIds, defaultCallResultTypeIds, callResultId, unconfirmed, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallFeedbackApi - interface
 * @export
 * @interface CallFeedbackApi
 */
export interface CallFeedbackApiInterface {
    /**
     * コールFB一覧取得API
     * @summary コールFB一覧取得API
     * @param {number} [page] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<number>} [userIds] 
     * @param {Array<string>} [connectedTo] 
     * @param {Array<number>} [callResultTypeIds] 
     * @param {Array<number>} [defaultCallResultTypeIds] 
     * @param {number} [callResultId] 
     * @param {boolean} [unconfirmed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackApiInterface
     */
    getCallFeedbacks(page?: number, startDate?: string, endDate?: string, userIds?: Array<number>, connectedTo?: Array<string>, callResultTypeIds?: Array<number>, defaultCallResultTypeIds?: Array<number>, callResultId?: number, unconfirmed?: boolean, options?: AxiosRequestConfig): AxiosPromise<GetCallFeedbacks200Response>;

}

/**
 * Request parameters for getCallFeedbacks operation in CallFeedbackApi.
 * @export
 * @interface CallFeedbackApiGetCallFeedbacksRequest
 */
export interface CallFeedbackApiGetCallFeedbacksRequest {
    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly endDate?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly userIds?: Array<number>

    /**
     * 
     * @type {Array<string>}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly connectedTo?: Array<string>

    /**
     * 
     * @type {Array<number>}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly callResultTypeIds?: Array<number>

    /**
     * 
     * @type {Array<number>}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly defaultCallResultTypeIds?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly callResultId?: number

    /**
     * 
     * @type {boolean}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly unconfirmed?: boolean
}

/**
 * CallFeedbackApi - object-oriented interface
 * @export
 * @class CallFeedbackApi
 * @extends {BaseAPI}
 */
export class CallFeedbackApi extends BaseAPI implements CallFeedbackApiInterface {
    /**
     * コールFB一覧取得API
     * @summary コールFB一覧取得API
     * @param {CallFeedbackApiGetCallFeedbacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackApi
     */
    public getCallFeedbacks(requestParameters: CallFeedbackApiGetCallFeedbacksRequest = {}, options?: AxiosRequestConfig) {
        return CallFeedbackApiFp(this.configuration).getCallFeedbacks(requestParameters.page, requestParameters.startDate, requestParameters.endDate, requestParameters.userIds, requestParameters.connectedTo, requestParameters.callResultTypeIds, requestParameters.defaultCallResultTypeIds, requestParameters.callResultId, requestParameters.unconfirmed, options).then((request) => request(this.axios, this.basePath));
    }
}
